import React from 'react'
import SendPushMessage from '../features/sendPushMessage'

export default function SendPushMessagePage() {
    return (
        <SendPushMessage />
    )
}